import { UPDATE_SORT_BY } from "../constants";

export interface UpdateSortByAction {
    type: UPDATE_SORT_BY;
    data: { sortBy: string };
}
export function updateSortBy(parameters: { sortBy: string }): UpdateSortByAction {
    return {
        data: parameters,
        type: UPDATE_SORT_BY,
    };
}
